import React from 'react';
import { Col, Row } from 'reactstrap';
import footerLogo from '../../assets/img/mex/footerlogo.png';

const Piepagina = () => {
  return (
    <div>
      <div className="footer">
        <div className="contain">
          <Row>
            <Col lg={3} md={3} sm={6}>
              <div className="col" />
            </Col>
          </Row>
          <Row>
            <Col lg={3} md={3} sm={6} className=" hidden-xs ">
              <div className="col">
                <ul>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Seguro para Autos
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Quiénes Somos
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Siniestros
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Contáctanos
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Talento
                    </a>
                  </li>
                  <li>
                    <a href="/faqs" target="_blank" style={{ color: '#a8a8aa' }}>
                      Preguntas Frecuentes
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={3} md={3} sm={6} className=" hidden-xs ">
              <div className="col">
                <ul>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Pago en Línea
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Educación Financiera AIG
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Sitio Agentes y Brokers
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Herramientas Web
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      AIG Garanplus
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={3} md={3} sm={6}>
              <div className="col">
                <ul>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      UNE
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      CONDUSEF
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Buró de entidades Financieras
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Advertencia contra el fraude
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      Consulta tu Factura
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={8} md={7} sm={7}>
              <div className="col">
                <ul>
                  <li style={{ borderBottom: 'none' }}>
                    <span className={'classFooterFontFamily'}>México |</span>
                    <a href="/" target="_blank" style={{ color: '#a8a8aa' }}>
                      {' '}
                      Worldwide{' '}
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={4} md={5} sm={5}>
              <div className="col">
                <ul>
                  <img src={footerLogo} className={'img-footer'} alt="IMG_LOGO" />
                </ul>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12} md={12} sm={12}>
              <div className="col">
                <ul>
                  <li style={{ borderBottom: 'none' }}>
                    <a href="/" target="_blank" style={{ color: '#ffff' }}>
                      Terminos y Condiciones de Uso
                    </a>{' '}
                    {' | '}{' '}
                    <a href="/" target="_blank" style={{ color: '#ffff' }}>
                      Documentos de Interés
                    </a>
                    {' | '}{' '}
                    <a href="/" target="_blank" style={{ color: '#ffff' }}>
                      Avisos de Privacidad
                    </a>
                    {' | '}{' '}
                    <a href="/" target="_blank" style={{ color: '#ffff' }}>
                      Preceptos Legales
                    </a>
                  </li>
                  <li style={{ borderBottom: 'none' }}>
                    <div
                      className={'classFooterFontFamily'}
                    >{`Copyright © ${new Date().getFullYear()} American International Group, Inc. Todos los derechos reservados.`}</div>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Piepagina;
